import React from 'react';
import { Flex } from 'antd';

const SidePaneContext = React.createContext<HTMLElement | null>(null);

export const useSidePane = (): HTMLElement | null => React.useContext(SidePaneContext);

export function WithSidePane({ children }: React.PropsWithChildren) {
  const [sidePane, setSidePane] = React.useState<HTMLElement | null>(null);

  return (
    <SidePaneContext.Provider value={sidePane}>
      <Flex>
        <Flex vertical flex={1} style={{ minWidth: 0 }}>
          {children}
        </Flex>
        <Flex ref={setSidePane} style={{ position: 'sticky', top: 0, height: '100vh', alignSelf: 'flex-start' }} />
      </Flex>
    </SidePaneContext.Provider>
  );
}
